export default "__VITE_ASSET__AD4i_0Ca__"